export const backEndURL = "http://127.0.0.1:8000/";
export const backEndIconsURL = "http://127.0.0.1:8000/icons/";
export const backEndProfilePictureURL =
  "http://127.0.0.1:8000/profile_pictures/";
export const backendIconsURL = "http://127.0.0.1:8000/icons/";
export const projectPrimaryColor = "#596EFD";
export const projectSecondaryColor = "#C3CAFB";
export const projectTertiaryColor = "#4C63FB";
export const projectLogoLight = (
  <a href="../dashboard" className="az-logo" style={{ color: "#e0e0e0" }}>
    Fa<span>to</span>res
  </a>
);
export const projectLogoBlack = (
  <a href="../dashboard" className="az-logo" style={{ color: "black" }}>
    Fa<span>to</span>res
  </a>
);
